<template>
  <div class="file-wrapper" :class="{ folder: isFolder }">
    <div class="file-name" @click="itemClick" @dblclick="itemDblClick">
      <svg-icon :icon="isFolder ? 'folder' : 'note'" class="mr-2 primary--text" />
      <div class="file-name-text" :data-folder="isFolder ? 1 : 0">{{ data.title }}</div>
    </div>
    <div class="file-action" v-if="isVisible">
      <v-btn text class="btn-action-custom" @click="edit"><svg-icon icon="edit" class="primary--text"/></v-btn>
      <v-btn text class="ml-1 btn-action-custom" @click="remove" v-if="canModified"><svg-icon icon="delete" class="red--text"/></v-btn>
    </div>
  </div>
</template>

<script>
import EventBus from '@/plugins/eventBus';

export default {
  name: 'FileItem',
  computed: {
    isFolder() {
      return this.data?.folder ?? false;
    },
    isVisible() {
      if (this.data.role == 4) {
        if (this.isFolder) {
          return this.data.folderOwner;
        } else {
          return true;
        }
      }
      return false;
    },
    canModified() {
      if (this.isFolder) {
        return this.data.folderOwner;
      } else {
        return this.data.owner;
      }
    }
  },
  data: () => ({ data: {} }),
  methods: {
    getExtension(data) {
      return data?.extension ? `.${data.extension}` : '';
    },
    itemClick() {
      if (this.isFolder) {
        EventBus.$emit('treeItemClick', this.data);
      }
    },
    itemDblClick() {
      if (!this.isFolder) {
        EventBus.$emit('treeItemClick', this.data);
      }
    },
    edit() {
      EventBus.$emit('treeItemEdit', this.data);
    },
    remove() {
      EventBus.$emit('treeItemRemove', this.data);
    }
  }
};
</script>

<style lang="scss" scoped>
.file {
  &-name {
    flex: 1;
    display: flex;
    align-items: center;

    &-text {
      &:after {
        content: attr(data-ext);
      }
    }
  }

  &-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    pointer-events: auto;
  }

  &-action {
    position: absolute;
    right: 0;
    display: none;
    align-items: center;
    background: #fff;
    padding: 6px;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba($color: #000000, $alpha: 0.1);
    border: 1px solid #ddd;

    .v-btn {
      height: 24px;
      line-height: 24px;
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
